var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41836 5.44111C6.41836 5.2099 6.23091 5.02246 5.99971 5.02246C5.7685 5.02246 5.58105 5.2099 5.58105 5.44111V8.79031C5.58105 9.02152 5.7685 9.20896 5.99971 9.20896C6.23091 9.20896 6.41836 9.02152 6.41836 8.79031V5.44111Z",
    fill: "#608BC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99934 0C2.686 0 0 2.686 0 5.99934C0 9.31271 2.686 11.9987 5.99934 11.9987C9.31271 11.9987 11.9987 9.31271 11.9987 5.99934C11.9987 2.686 9.31271 0 5.99934 0ZM0.837118 5.99934C0.837118 3.14833 3.14833 0.837118 5.99934 0.837118C8.85034 0.837118 11.1616 3.14833 11.1616 5.99934C11.1616 8.85034 8.85034 11.1616 5.99934 11.1616C3.14833 11.1616 0.837118 8.85034 0.837118 5.99934Z",
    fill: "#608BC1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55781 3.76718C6.55781 4.07547 6.3079 4.32539 5.99961 4.32539C5.69131 4.32539 5.44141 4.07547 5.44141 3.76718C5.44141 3.4589 5.69131 3.20898 5.99961 3.20898C6.3079 3.20898 6.55781 3.4589 6.55781 3.76718Z",
    fill: "#608BC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpInfo);
export default __webpack_public_path__ + "static/media/expInfo.62c8f54288227e0cb98d2e17dd1689bb.svg";
export { ForwardRef as ReactComponent };